.ehr-body{width:100%}.container{width:100%;height:100%}
/*# sourceMappingURL=ehr.component-IZBMWW5G.css.map */
